<template>
  <o-section
    :title="label || schema.verbose_name"
    not-closable
    :level="level + 1"
    body-classes="p-0"
  >
    <o-item-editable-table
      v-model="items"
      :default-new-value="newChild"
      :form-state="formState"
      :item-name="schema.verbose_name"
      @change="changed"
    >
      <template slot="o-headers">
        <th v-if="canSee(schema, 'name')">{{ schema.fields.name.label }}</th>
        <th v-if="canSee(schema, 'activities')">
          {{ schema.fields.activities.label }}
        </th>
        <th v-if="canSee(schema, 'triggers')">
          {{ schema.fields.triggers.label }}
        </th>
        <th v-if="canSee(schema, 'process')">
          {{ schema.fields.process.label }}
        </th>
        <th v-if="canSee(schema, 'from_state')">
          {{ schema.fields.from_state.label }}
        </th>
        <th v-if="canSee(schema, 'to_state')">
          {{ schema.fields.to_state.label }}
        </th>
      </template>
      <template slot="o-body" slot-scope="{ item, index }">
        <td v-if="canSee(schema, 'name')">
          <o-widget-wrapper
            :schema="schema"
            name="name"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-text-field
              v-model="items[index].name"
              :form-state="formState"
              name="name"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.name"
            ></o-text-field>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'activities')">
          <o-widget-wrapper
            :schema="schema"
            name="activities"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <process-activity-form-table
              v-model="items[index].activities"
              :validators="validators.$each[index].activities"
              :form-state="formState"
              :label="schema.fields.activities.label"
              :level="level + 1"
              :server-errors="_se.activities"
            >
            </process-activity-form-table>
            <!-- UNCOMMENT TO USE Cards
<process-activity-form-cards v-model="items[index].activities"
    :validators="validators.$each[index].activities"
    :form-state="formState"
    :label="schema.fields.activities.label"
    :level="level+1"
    :server-errors="_se.activities">
</process-activity-form-cards>
-->
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'triggers')">
          <o-widget-wrapper
            :schema="schema"
            name="triggers"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <process-trigger-form-table
              v-model="items[index].triggers"
              :validators="validators.$each[index].triggers"
              :form-state="formState"
              :label="schema.fields.triggers.label"
              :level="level + 1"
              :server-errors="_se.triggers"
            >
            </process-trigger-form-table>
            <!-- UNCOMMENT TO USE Cards
<process-trigger-form-cards v-model="items[index].triggers"
    :validators="validators.$each[index].triggers"
    :form-state="formState"
    :label="schema.fields.triggers.label"
    :level="level+1"
    :server-errors="_se.triggers">
</process-trigger-form-cards>
-->
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'process')">
          <o-widget-wrapper
            :schema="schema"
            name="process"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].process"
              :items="optionProcessItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              :form-state="formState"
              :loading="optionProcessWorking"
              name="process"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.process"
              allow-add
              store-name="Process"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <process-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></process-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'from_state')">
          <o-widget-wrapper
            :schema="schema"
            name="from_state"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].from_state"
              :items="optionProcessStateItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              :form-state="formState"
              :loading="optionProcessStateWorking"
              name="from_state"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.from_state"
              allow-add
              store-name="ProcessState"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <process-state-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></process-state-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
        <td v-if="canSee(schema, 'to_state')">
          <o-widget-wrapper
            :schema="schema"
            name="to_state"
            :validators="validators.$each[index]"
            :server-errors="_se"
            :server-errors-index="index"
            :form-state="formState"
          >
            <o-select
              v-model="items[index].to_state"
              :items="optionProcessStateItems"
              text-field="name"
              value-field="id"
              sort-field="name"
              :form-state="formState"
              :loading="optionProcessStateWorking"
              name="to_state"
              :validators="validators.$each[index]"
              :server-errors="_se"
              :server-errors-index="index"
              nolabel
              v-bind="schema.fields.to_state"
              allow-add
              store-name="ProcessState"
              add-title="Create New"
            >
              <template
                slot="form"
                slot-scope="{ item, formState, serverErrors }"
              >
                <process-state-form
                  :item="item"
                  :form-state="formState"
                  :server-errors="serverErrors"
                  in-modal
                ></process-state-form>
              </template>
            </o-select>
          </o-widget-wrapper>
        </td>
      </template>
    </o-item-editable-table>
  </o-section>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import schema from "../../schema/index";
import { cleanUpModel } from "../../../../vue-ocom/schema/schema_vuetify";
import { CreateDefaultItem } from "../../../../vue-ocom/schema/schema_utils";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
} from "../../../../vue-ocom/mixins";
import OItemEditableTable from "../../../../vue-ocom/components/table/OItemEditableTable";
import OSection from "../../../../vue-ocom/components/layout/OSection";

import { default as ProcessTriggerFormTable } from "../../process_trigger/components/ItemFormTable";
import { default as ProcessActivityFormTable } from "../../process_activity/components/ItemFormTable";

export default {
  name: "ProcessTransitionFormTable",
  mixins: [
    CreateFormStateMixin("validators"),
    CreateGroupPermissionMixin("ProcessTransition"),
    CreateCodeTableFetchMixin(["ProcessState", "ProcessState", "Process"]),
  ],
  components: {
    OItemEditableTable,
    OSection,
    ProcessTriggerFormTable,
    ProcessActivityFormTable,
  },
  model: {
    prop: "items",
    event: "changed",
  },
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    label: { type: String, default: null },
    validators: { type: Object, default: () => null },
    level: { type: Number, default: 0 },
  },
  data: function () {
    return {
      schemaModel: cleanUpModel(
        schema.ProcessTransition,
        {}
      ) /*Use this.schema instead */,
      newChild: CreateDefaultItem(schema.ProcessTransition),
    };
  },
  methods: {
    changed() {
      if (this.validator) {
        this.validator.$touch();
      }

      if (this.formState) this.formState.dirty = true;

      this.$emit("changed", this.items);
    },
  },
  computed: {},
  created() {
    // this.loadCodeTables()
  },
};
</script>